<template>
<div id="portfolio" class= "container">
    
    
    <div class="main middlediv">
        <h3 id="top" class="titlespace">
        Portfolio
        </h3>
        <p class="portfolioparagraph">
            Here are a few projects I have completed recently, Most of the projects are responsive. I also have Github Repository for all  projects, all the projects are open source and anyone can use them in there projects, whether it is a college project or for a company.
            <br>
            If you are pre-final year or final year college students of Engineering, looking for help in your final year projects, then you can <router-link to="/contact">contact me!</router-link> here.
        </p>


    
        <div class="row">
            <div class="col-sm-10 offset-sm-1">
                <div id="1" class="card">
                    <img class="card-img-top img-fluid" src="../assets/4.png" >
                    <div class="card-block">
                        <p class="card-text">An Employee Managment Project which can perform CRUD Operations. I have used Vuejs and Firestore to develop this Project.
                            <span style="float:right;"><a href="https://khudania.github.io/employee_management_system/" target="_blank"><i class="fa fa-external-link" aria-hidden="true"></i></a></span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
  
        
        <div class="row">
            <div class="col-sm-10 offset-sm-1">
                    <div id ="2" class="card middlediv">
                            <img class="card-img-top img-fluid" src="../assets/8.png">
                            <div class="card-block">
                                <p class="card-text">A side-project, using css, I have created a fully responsive web page design.
                                        <span style="float:right;"><a href="https://khudania.github.io/responsive-website-using-css/" target="_blank"><i class="fa fa-external-link" aria-hidden="true"></i></a></span>
                                </p>
                                
                            </div>
                        </div>
            </div>
            
        </div>


        <div class="row">
                <div class="col-sm-10 offset-sm-1">
                    <div id ="3" class="card middlediv">
                        <img class="card-img-top img-fluid" src="../assets/7.png">
                        <div class="card-block">
                            <p class="card-text">As a side-project, I have created s very simple Parallex theme webpage using HTML & CSS
                                    <span style="float:right;"><a href="https://khudania.github.io/basic-parallex-website/" target="_blank"><i class="fa fa-external-link" aria-hidden="true"></i></a></span>
                            </p>
                            
                        </div>
                    </div>
                </div>
                
        </div>


        <div class="row">
            <div class="col-sm-10 offset-sm-1">
                <div id ="4" class="card middlediv">
                    <img class="card-img-top img-fluid" src="../assets/6.png" >
                    <div class="card-block">
                        <p class="card-text">In this Project I have created a CMS Admin Dashboard Theme using HTML, CSS and Bootstrap 3.
                                <span style="float:right;"><a href="https://khudania.github.io/CMS-admin-panel-theme/" target="_blank"><i class="fa fa-external-link" aria-hidden="true"></i></a></span>
                        </p>
                       
                    </div>
                </div>
            </div>
        </div>

        

        <div class="row">
            <div class="col-sm-10 offset-sm-1">
                <div id ="5" class="card middlediv">
                    <img class="card-img-top img-fluid" src="../assets/5.png" >
                    <div class="card-block">
                        <p class="card-text">Created a Website Launching Page with Countdown Timer using javaScript.
                                <span style="float:right;"><a href="https://khudania.github.io/comingsoon/" target="_blank"><i class="fa fa-external-link" aria-hidden="true"></i></a></span>
                        </p>
                        
                    </div>
                </div>  
            </div>
        </div>

        <div class="row">
            <div class="col-sm-10 offset-sm-1">
                <div id ="5" class="card middlediv">
                    <img class="card-img-top img-fluid" src="../assets/3.png">
                    <div class="card-block">
                        <p class="card-text">In this side-project, I have created a very simple full screen landing Page.
                                <span style="float:right;"><a href="https://khudania.github.io/full-screen-landing-page/" target="_blank"><i class="fa fa-external-link" aria-hidden="true"></i></a></span>
                        </p>
                        
                    </div>
                </div>  
            </div>
        </div>

        <div class="row">
            <div class="col-sm-10 offset-sm-1">
                <div id ="5" class="card middlediv">
                    <img class="card-img-top img-fluid" src="../assets/2.png" >
                    <div class="card-block">
                        <p class="card-text"> A side-project in which I have created a fully responsive webpage theme using CSS Grid.
                                <span style="float:right;"><a href="https://khudania.github.io/css-grid-sample-webpage/" target="_blank"><i class="fa fa-external-link" aria-hidden="true"></i></a></span>
                        </p>
                        
                    </div>
                </div>  
            </div>
        </div>

        <div class="row">
            <div class="col-sm-10 offset-sm-1">
                <div id ="5" class="card middlediv">
                    <img class="card-img-top img-fluid" src="../assets/1.png" >
                    <div class="card-block">
                        <p class="card-text"> In these project I have created a responsive Travel website theme using MaterializeCSS
                                <span style="float:right;"><a href="https://khudania.github.io/TravelWebsiteTheme/" target="_blank"><i class="fa fa-external-link" aria-hidden="true"></i></a></span>
                        </p>
                        
                    </div>
                </div>  
            </div>
        </div>


     <div class="row">
            <div class="col-sm-10 offset-sm-1">
                <div id ="5" class="card middlediv">
                    <img class="card-img-top img-fluid" src="../assets/10.png" >
                    <div class="card-block">
                        <p class="card-text"> In these project I have created a react and chartjs app to display the population of some of the cities of Karnataka
                                <span style="float:right;"><a href="https://khudania.github.io/chartJsApp/" target="_blank"><i class="fa fa-external-link" aria-hidden="true"></i></a></span>
                        </p>
                        
                    </div>
                </div>  
            </div>
        </div>



    <div class="row">
            <div class="col-sm-10 offset-sm-1">
                <div id ="5" class="card middlediv">
                    <img class="card-img-top img-fluid" src="../assets/9.png" >
                    <div class="card-block">
                        <p class="card-text"> In these project I have created a react and chartjs app to display the population of some of the cities of Karnataka
                                <span style="float:right;"><a href="http://reactchartjsapp.netlify.com/" target="_blank"><i class="fa fa-external-link" aria-hidden="true"></i></a></span>
                        </p>
                        
                    </div>
                </div>  
            </div>
        </div>


    <div class="row">
            <div class="col-sm-10 offset-sm-1">
                <div id ="5" class="card middlediv">
                    <img class="card-img-top img-fluid" src="../assets/11.png" >
                    <div class="card-block">
                        <p class="card-text"> Created a very basic Wedding Invitation Template
                                <span style="float:right;"><a href="https://khudania.github.io/Wedding_template/" target="_blank"><i class="fa fa-external-link" aria-hidden="true"></i></a></span>
                        </p>
                        
                    </div>
                </div>  
            </div>
        </div>

        <p class="navigationpointers" data-aos="fade-up" id="end">
            <br><a href="#top"><i class="fa fa-angle-double-up pointer" aria-hidden="true"></i></a>
        </p>
  </div>
</div>


</template>

<script>
export default {
  name: 'portfolio',
    data (){
        return {
            
        }
    }
}
</script>

<style scoped>
.middlediv {
  margin-top: 60px;
}

.main {
  padding-left: 12%;
  padding-right: 12%;
}

.titlespace {
  margin-bottom: 50px;
}


.portfolioparagraph {
  margin-bottom: 30px;
}

.card {
  -moz-box-shadow: 0 0 50px 5px rgb(165, 164, 164);
  -webkit-box-shadow: 0 0 40px 5px rgb(165, 165, 165);
}


.card-text {
  font-family: 'Quicksand', sans-serif;
  font-size: small;
  padding: 2px 5px 2px 5px;  
}

p{
    font-family: cursive
}
</style>



// WEBPACK FOOTER //
// src/components/Portfolio.vue